export const SCREEN_SIZES = {
    SM: 640,
    MD:768,
    LG:1023,
}